import React from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import ObituaryForm from "./ObituaryForm";
import PeopleToInformFrom from "./PeopleToInformFrom";
import OrganizationsToContact from "./OrganizationsToContact";
import {
    starSetObituary,
    starSetPeopleToInform,
    starSetOrganizationToContact,
    createObituary,
    setObituary,
    starGetObituary,
    getObituary
} from "../../actions/obituary";
import { pushToDataLayer } from '../../utils/gtmUtils';

class ObituaryPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: 0,
            tabs: [
                {
                    id: 0,
                    name: 'Avis de décès'
                },
                {
                    id: 1,
                    name: 'Personnes à informer'
                },
                {
                    id: 2,
                    name: 'Organismes à contacter'
                },

            ],
            promiseIsResolved: false
        }
    }

    componentWillMount() {
        const self = this;
        this.props.starGetObituary(this.props.beneficiaryData.idBeneficiaire, this.props.partenaireData.id).then((response) => {
            let data = response.data;
             data.obituaryData = {
                id : data.id,
                displayObituary : data.displayObituary,
                newspapers : data.newspapers,
                obituaryText : data.obituaryText
            }
            if (data.listToInform) {
                data.listToInform.map(obj => obj.error = {});
                data.peopleToInformData = data.listToInform.filter(x => x.type === 'NATURAL');
                data.organizationsToContactData = data.listToInform.filter(x => x.type === 'LEGAL');



                this.props.starSetPeopleToInform(data.peopleToInformData);
            }
            self.setState({ data: response.data, promiseIsResolved: true });
            this.props.getObituary(data.obituaryData);

        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.peopleToInformData !== this.props.peopleToInformData) {
            //console.log('new liste to inform', this.props.obituaryData);
            this.setState(prevState => ({
                data: {
                    ...prevState.data,
                    peopleToInformData: this.props.peopleToInformData.list,
                    obituaryData : this.props.obituaryData
                }
            }));
        }
    }


    selectTab = (selected) => {
        this.setState({ selected });
    }

    onObituarySubmit = (obituaryData) => {
        this.props.starSetObituary(obituaryData);
        this.setState(() => ({ selected: 1 }));
    };
    onPeopleToInformSubmit = (peopleToInformData) => {
        this.props.starSetPeopleToInform(peopleToInformData);
        this.setState(() => ({ selected: 2 }));
    }
    onOrganizationsToContactSubmit = (organizationsToContactData) => {
        this.props.starSetOrganizationToContact(organizationsToContactData);
        this.postObitary(this.props.obituaryData, this.props.peopleToInformData.list, organizationsToContactData);
    }
    
    goBack = (e) => {
        e.preventDefault();
        if (this.state.selected === 0) {
            this.props.history.push('/accueil');
        } else {
            this.selectTab(this.state.selected - 1);
        }
        this.setState(prevState => ({
            data: {
                ...prevState.data,
               obituaryData : this.props.obituaryData
            }
        }));
    }
    
    postObitary = (obituaryData, peopleToInformData, organizationsToContactData) => {
        const dataLayer = {
            event: "deathNoticeSave",
            url: window.location.href,
            idPartenaire: this.props.partenaireData.id
        }
        pushToDataLayer(dataLayer);

        obituaryData.listToInform = [];
        const idBenef = this.props.beneficiaryData.idBeneficiaire;
        obituaryData.displayObituary = !!+obituaryData.displayObituary;
        obituaryData.idBeneficiaire = idBenef;
        if (organizationsToContactData !== "") {
            organizationsToContactData.forEach(function (element) {
                element.idBeneficiaire = idBenef;
                element.type = "LEGAL";
                obituaryData.listToInform.push(element);
            });
        }

        if (peopleToInformData !== "") {
            peopleToInformData.forEach(function (element) {
                element.idBeneficiaire = idBenef;
                element.type = "NATURAL";
                obituaryData.listToInform.push(element);
            });
        }
        this.props.createObituary(obituaryData, this.props.partenaireData.id).then(response => {
            this.props.history.push('/accueil');
            this.props.setObituary(obituaryData);
        }).catch(function (error) {
            console.log('erorr', error);
        })
    }

    render() {
    	if (!this.state.promiseIsResolved) { return null }
        return (
            <div className="memory-page container main-container">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to="/">Accueil</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">Mon avis de décès</li>
                </ol>
                <h1 className="text-center">Mon avis de décès</h1>
                <div className="intro-text">
                    Vous pouvez, si vous le souhaitez, rédiger le texte de votre avis de décès et indiquer le(s) media(s) dans lesquels le diffuser.
                	Indiquez également à votre chargé de mémoire les personnes et les organismes qui doivent être informés de votre décès.
                </div>
                <ul className="tab-list">
                    {
                        this.state.tabs.map((tab, i) =>
                            <li
                                key={i}
                                className={this.state.selected === tab.id ? 'tab-item active' : 'tab-item'}>{tab.name}
                            </li>
                        )
                    }
                </ul>
                {this.state.selected === 0 && this.state.data ?

                    <ObituaryForm onObituarySubmit={
                        this.onObituarySubmit} data={this.state.data.obituaryData
                        } back={this.goBack} /> : <div></div>}


                {this.state.selected === 1 &&
                    <PeopleToInformFrom onPeopleToInformSubmit=
                        {this.onPeopleToInformSubmit}
                        peopleToInformData={this.state.data.peopleToInformData}
						back={this.goBack}
                        countryData={this.props.countryData} />}



                {this.state.selected === 2 &&
                    <OrganizationsToContact onOrganizationsToContactSubmit=
                        {this.onOrganizationsToContactSubmit}
                        organizationsToContact={this.state.data.organizationsToContactData}
                        back={this.goBack} />}




            </div>
        )
    }

}


const mapDispatchToProps = (dispatch) => ({
    starSetObituary: (obituaryData) => dispatch(starSetObituary(obituaryData)),
    starSetPeopleToInform: (peopleToInformData) => dispatch(starSetPeopleToInform(peopleToInformData)),
    starSetOrganizationToContact: (organizationToContactData) => dispatch(starSetOrganizationToContact(organizationToContactData)),
    createObituary: (obituaryData, idPartner) => dispatch(createObituary(obituaryData, idPartner)),
    starGetObituary: (benefId, idPartner) => dispatch(starGetObituary(benefId, idPartner)),
    getObituary: (data) => dispatch(getObituary(data)),
    setObituary: (data) => dispatch(setObituary(data)),
});

const mapStateToProps = state => ({
    obituaryData: state.obituaryData,
    peopleToInformData: state.peopleToInformData,
    beneficiaryData: state.beneficiaryData.idBeneficiaire ? state.beneficiaryData : JSON.parse(sessionStorage.getItem('benef')),
    countryData: state.countryData,
    partenaireData: state.partenaireData
})

export default connect(mapStateToProps, mapDispatchToProps)(ObituaryPage);





// WEBPACK FOOTER //
// ./src/components/ObituaryPage/ObituaryPage.js